var style = {"z-p1":"z-p1","z-p1--bold":"z-p1--bold","z-p2":"z-p2","z-p2--bold":"z-p2--bold","z-p3":"z-p3"};

export { style as default };
//# sourceMappingURL=Paragraph.module.scss.js.map
